import React from 'react';
import './OurHistory.css';
import historyImage from './../../assets/images/trailer.webp';

const OurHistory = () => {

  return (
    <div className='our-history-content-wrapper'>
        <div className='history-column'>
            <div className='history-column-header'>
                <h2>Our History</h2>
            </div>

            <div className='history-column-content'>
                <p>
                    Beginning in Ohio over 25 years ago, we are proud to be a small, family-owned and operated company, which means we can personally stand behind the quality and promptness of every job.
                    <br/>
                    <br/>
                    Now under new ownership, Gutters By Watkins continues to use the same trusted techniques and premium materials that built our reputation, but now with fresh new faces and a team dedicated to carrying that tradition forward.
                    <br/>
                    <br/>
                    Located in Ocklawaha, FL we proudly serve Marion, Lake, and Sumter Counties with the best gutter services in Central Florida! Ranging from Ocala to Leesburg with many gutter installations in The Villages, we are proud of our extraordinary 5-star rating from hundreds of satisfied clients who have discovered that there is truly a difference when you have
                    <span style={{display: 'unset', fontStyle: 'italic'}}> Gutters By Watkins.</span>
                </p>
            </div>
        </div>
        <div className='history-column'>
            <div className='history-img-wrapper'>
                <img src={historyImage} alt='A Watkins Seamless Gutters trailer parked in sand with a ladder on top of it, preparing for a gutter installation. The trailer is branded with company details, including contact information.' height={'1080'} width={'1440'}></img>
            </div>
        </div>

    </div>
  );
};

export default OurHistory;
